import React from 'react';
import PropTypes from 'prop-types';
import CheckboxDropdown from './CheckboxDropdown';
import CheckboxDropdownBody from './CheckboxDropdown/CheckboxDropdownBody/CheckboxDropdownBody';
import CheckboxDropdownButton from './CheckboxDropdown/CheckboxDropdownButton';
import { CheckboxDropdownProvider } from './context';
function CheckboxDropdownContainer(props) {
  const {
    value = [],
    className = ''
  } = props;
  return /*#__PURE__*/React.createElement(CheckboxDropdownProvider, {
    value: value
  }, /*#__PURE__*/React.createElement(CheckboxDropdown, {
    className: className
  }, /*#__PURE__*/React.createElement(CheckboxDropdownButton, null), /*#__PURE__*/React.createElement(CheckboxDropdownBody, props)));
}
CheckboxDropdownContainer.propTypes = {
  value: PropTypes.array,
  className: PropTypes.string,
  menuPlacement: PropTypes.string,
  menuClassName: PropTypes.string
};
export default CheckboxDropdownContainer;